// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1xj6d"};